const fontSize = 14; // px
const htmlFontSize = 16;
const coef = fontSize / 14;

// const fontSizeCalc = (expectedBodyFontSize) => {
//   return (14 / 16) * expectedBodyFontSize;
// };

export const pxToRem = (size) => `${(size / htmlFontSize) * coef}rem`;

export function themeTypography(theme) {
  return {
    htmlFontSize,
    // fontSize: fontSizeCalc(fontSize),
    fontFamily: ["Oxygen"].join(","),
    h1: {
      fontSize: pxToRem(88),
      fontWeight: 700,
    },
    h2: {
      fontSize: pxToRem(57),
      fontWeight: 600,
    },
    h3: {
      fontSize: pxToRem(48),
      fontWeight: 600,
    },
    h4: {
      fontSize: pxToRem(34),
      fontWeight: 500,
    },
    h5: {
      fontSize: pxToRem(24),
      fontWeight: 500,
    },
    h6: {
      fontSize: pxToRem(20),
      fontWeight: 400,
    },
    title: {
      fontSize: pxToRem(34),
      fontWeight: 600,
    },
    title1: {
      fontSize: pxToRem(20),
      fontWeight: 500,
    },
    subtitle: {
      fontSize: pxToRem(20),
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: pxToRem(15),
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: pxToRem(14),
      fontWeight: 400,
    },
    subtitle3: {
      fontSize: pxToRem(15),
      fontWeight: 600,
    },
    subtitle4: {
      fontSize: pxToRem(14),
      fontWeight: 600,
    },
    subtitle5: {
      fontSize: pxToRem(14),
      fontWeight: 500,
    },
    body4: {
      fontSize: pxToRem(15),
      fontWeight: 500,
    },
    body3: {
      fontSize: pxToRem(16),
      fontWeight: 500,
    },
    body2: {
      fontSize: pxToRem(16),
      fontWeight: 600,
    },
    body1: {
      fontSize: pxToRem(16),
      fontWeight: 400,
    },
    body: {
      fontSize: pxToRem(14),
      fontWeight: 300,
    },
    caption: {
      fontSize: pxToRem(12),
      fontWeight: 400,
    },
    caption1: {
      fontSize: pxToRem(12),
      fontWeight: 500,
    },
    caption2: {
      fontSize: pxToRem(10),
      fontWeight: 400,
    },
  };
}
